<template>
  <div class="app-quote-checkbox" :class="{ checked: newValue }">
    <label>
      <input type="checkbox" v-model="newValue" @change="onInput" />
      <span class="label">{{ label }}</span>
    </label>
    <p class="message" v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: [Boolean],
    label: String,
    message: String,
    disabled: Boolean,
  },

  data() {
    return {
      newValue: this.value,
    };
  },

  watch: {
    value() {
      this.newValue = this.value;
    },
  },

  methods: {
    onInput() {
      if (this.disabled) {
        this.value = true;
        this.newValue = true;
      }
      this.$emit("input", this.newValue);
      this.$emit("change", this.newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-quote-checkbox {
  position: relative;

  label {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 206px;
    height: 75px;
    border: solid 1px $medium-gray;
    background-color: $white;
    transition: border 0.2s ease-in-out;
    cursor: pointer;

    @media all and (max-width: $mobile) {
      width: 102px;
      height: 52px;
    }

    span.label {
      font-size: 25px;
      font-weight: $font-light;
      line-height: 1.32;
      color: $black;
      transition: color 0.2s ease-in-out;

      @media all and (max-width: $mobile) {
        font-size: 20px;
        font-weight: $font-light;
      }
    }
  }

  &.checked {
    label {
      border: 1px solid $primary-blue;
    }

    span.label {
      color: $primary-blue;
    }
  }

  input {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    z-index: 2;
    cursor: pointer;
  }

  .message {
    font-size: 1em;
    margin: 10px 0 0;
    color: $error-red;
    font-weight: $font-normal;
  }
}
</style>
